let cryptoConfig = {
  AES_KEY: null,
  AES_IV: null,
  SECRET_KEY: null,
  SALT: null
};

let resolveCrypto;
const cryptoReadyPromise = new Promise((resolve) => {
  resolveCrypto = resolve;
});

export const setCryptoConfig = (config) => {
  cryptoConfig = config;
  resolveCrypto(); // 🔥 Resolve when keys are set
};

export const getCryptoConfig = () => cryptoConfig;

export const waitForCrypto = () => cryptoReadyPromise;
